import React, { useEffect, useState } from 'react'
import TextFieldUniversal from '../../validate/form/text/TextFieldUniversal'

const DisagreeTextMain = ({ required, setValidate, setValueForm, forciblyValue, className }) => {

  	const [value, setValue] = useState('')

  return (
	<div className={className}>
		<TextFieldUniversal
			value={value}
			setValue={e => {
				setValueForm(e)
				setValue(e)
			}}
			setValidate={setValidate}
			label={'Причина відмови'} 
			placeholder={'Напишіть причину'}
			validates={{
				isEmpty: true,
			}}
			forciblyValue={forciblyValue}
			required={required}
			multiline
			rows={4}
		/>
	</div>
  )
}

export default DisagreeTextMain